import { defineStore } from 'pinia'

export const ShowAllDay = defineStore({
    id: 'wp_settings_sad',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const HideWeekends = defineStore({
    id: 'wp_settings_hw',
    state: () => {
        return { value: 1 }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
export const ShortenNames = defineStore({
    id: 'wp_settings_sn',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
